import React from 'react'

const Refunds = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Refunds</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Sales Audit Report</li>
            <li className="breadcrumb-item active">Refunds</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Refund Records</h5>
                <p>View and audit all refund transactions.</p>
                {/* Add refunds table/component here */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Refunds

